import { render, staticRenderFns } from "./SetSupportLvl.vue?vue&type=template&id=57228825"
import script from "./SetSupportLvl.vue?vue&type=script&lang=ts"
export * from "./SetSupportLvl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports